import { render, staticRenderFns } from "./AppLanding.vue?vue&type=template&id=72da6e9d&scoped=true&"
import script from "./AppLanding.vue?vue&type=script&lang=js&"
export * from "./AppLanding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72da6e9d",
  null
  
)

export default component.exports